"use strict";
// GENERATED WITH generate-main-exports
// Warning: Do not edit by hand, all changes will be lost on next execution!
exports.__esModule = true;
exports.forAllImagesInElement = exports.forDOMContentLoaded = exports.forAnimationFrame = exports.forDocumentReady = exports.forValueDefined = exports.forTimeSynced = exports.forImmediate = exports.forTimeout = exports.forImage = exports.forEver = exports.forTime = void 0;
var forAllImagesInElement_js_1 = require("./functions/forAllImagesInElement.js");
exports.forAllImagesInElement = forAllImagesInElement_js_1.forAllImagesInElement;
var forAnimationFrame_js_1 = require("./functions/forAnimationFrame.js");
exports.forAnimationFrame = forAnimationFrame_js_1.forAnimationFrame;
var forDocumentReady_js_1 = require("./functions/forDocumentReady.js");
exports.forDocumentReady = forDocumentReady_js_1.forDocumentReady;
var forDOMContentLoaded_js_1 = require("./functions/forDOMContentLoaded.js");
exports.forDOMContentLoaded = forDOMContentLoaded_js_1.forDOMContentLoaded;
var forEver_js_1 = require("./functions/forEver.js");
exports.forEver = forEver_js_1.forEver;
var forImage_js_1 = require("./functions/forImage.js");
exports.forImage = forImage_js_1.forImage;
var forImmediate_js_1 = require("./functions/forImmediate.js");
exports.forImmediate = forImmediate_js_1.forImmediate;
var forTime_js_1 = require("./functions/forTime.js");
exports.forTime = forTime_js_1.forTime;
var forTimeout_js_1 = require("./functions/forTimeout.js");
exports.forTimeout = forTimeout_js_1.forTimeout;
var forTimeSynced_js_1 = require("./functions/forTimeSynced.js");
exports.forTimeSynced = forTimeSynced_js_1.forTimeSynced;
var forValueDefined_js_1 = require("./functions/forValueDefined.js");
exports.forValueDefined = forValueDefined_js_1.forValueDefined;
